import { logoutEventDispatch } from '@space-lib-events/logout'
import { Actions, Entities } from '@space-lib/datahub'

import { useDataHubEvents } from '@space-shell/common/hooks/useDataHubEvents'
import { useGoogleAnalytics } from '@space-shell/common/hooks/useGoogleAnalytics'
import { CAS_FLOW_STORAGE_KEY } from '@space-shell/common/services/auth'
import { MonitoringUtils } from '@space-shell/common/utils/monitoring'

export const useLogout = () => {
  const { sendDataHubEvent } = useDataHubEvents()
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics()

  const logout = () => {
    sendDataHubEvent({
      group: Entities.HEADER_USER_MENU,
      name: Actions.CLICK_LOGOUT
    })

    sendGoogleAnalyticsEvent({
      group: Entities.HEADER_USER_MENU,
      name: Actions.CLICK_LOGOUT
    })

    sessionStorage.removeItem(CAS_FLOW_STORAGE_KEY)
    MonitoringUtils.trace({ message: '[AUTH] Voluntary logout' })
    logoutEventDispatch()
  }

  return { logout }
}
